const backgroundfilm = {
  background: `linear-gradient(
      to right,
      rgba(0, 0, 0, 0.5),
      rgba(248, 248, 255, 0.5)
    )`,
  backdropFilter: "blur(10px)",
  position: "fixed",
  width: "100%",
  height: "100%",
  top: "0%",
  left: "0%",
  zIndex: 1500,
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  placeItems: "center",
};

const guage = {
  height: "auto",
  background: `linear-gradient(
    to right bottom,
    rgba(248, 248, 255, 0.5),
    rgba(248, 248, 255, 0.05)
    )`,
  backdropFilter: "blur(1rem)",
  margin: "5px",
  borderRadius: "0.5rem",
  padding: "5px",
  boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
};

const input = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      backgroundColor: "transparent",
    },
    "&:hover fieldset": {
      // borderColor: "#00c800",
    },
    "&.Mui-focused fieldset": {
      // borderColor: "#006400",
    },
  },
  "& .MuiInputBase-input": {
    // color: "red",
    backgroundColor: "transparent",
    fontSize: "1rem",
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px transparent inset",
      WebkitTextFillColor: "grey",
      transition: "background-color 5000s ease-in-out 0s",
    },
    "&:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 1000px transparent inset",
      // WebkitTextFillColor: "white",
    },
    "&:-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0 1000px transparent inset",
      // WebkitTextFillColor: "white",
    },
  },
  "& .MuiFormLabel-root": {
    // color: "white",
  },
  "& .MuiFormLabel-root.Mui-focused": {
    // color: "white",
  },
};

export { backgroundfilm, guage, input };
